module.exports = __webpack_public_path__ + "img/13.93802a81.png";